import * as swcHelpers from '@swc/helpers';
import React__default from 'react';
import { Upload } from '@grandvisionhq/api-client';
import { useRecaptcha } from '@grandvisionhq/forms';
import { useApiConfig, statusSuccess, statusFailed, statusWarning, statusLoading, statusUninit } from '@grandvisionhq/state';
import { uploadStatusLoading, uploadStatusSuccess, uploadStatusIdle, uploadStatusError } from '../types.js';
import { useUpload } from '../UploadProvider/UploadProvider.js';
import { Upload as Upload$1 } from './Upload.js';

var UploadContainer = (_param)=>{
    var { scope , onStatusChange , uploadStatus , referenceId  } = _param, rest = swcHelpers.objectWithoutProperties(_param, [
        "scope",
        "onStatusChange",
        "uploadStatus",
        "referenceId"
    ]);
    const { getToken  } = useRecaptcha();
    const { apiUrl  } = useApiConfig();
    const { configs  } = useUpload();
    const scopeConfig = configs[scope];
    const controllerRef = React__default.useRef();
    const handleDropSuccess = React__default.useCallback(function() {
        var _ref = swcHelpers.asyncToGenerator(function*(file) {
            if (!scopeConfig || !statusSuccess(scopeConfig)) {
                return;
            }
            onStatusChange === null || onStatusChange === void 0 ? void 0 : onStatusChange(uploadStatusLoading());
            const { result: { isRecaptchaTokenRequired , maxFileNameLength  } ,  } = scopeConfig;
            try {
                var ref, ref1;
                controllerRef.current = new AbortController();
                const recaptchaToken = isRecaptchaTokenRequired ? yield getToken() : undefined;
                const { token: uploadToken  } = yield Upload.getUploadToken(apiUrl, {
                    scope,
                    referenceId,
                    recaptchaToken
                }, {
                    signal: (ref = controllerRef.current) === null || ref === void 0 ? void 0 : ref.signal
                });
                const isFileNameTooLong = file.name.length > maxFileNameLength;
                const { storageId , storageToken  } = yield Upload.sendFile(apiUrl, swcHelpers.objectSpread({
                    scope,
                    referenceId,
                    uploadedFile: file,
                    uploadToken
                }, isFileNameTooLong ? {
                    alias: file.name.slice(0, maxFileNameLength)
                } : {}), {
                    signal: (ref1 = controllerRef.current) === null || ref1 === void 0 ? void 0 : ref1.signal
                });
                const fileRef = {
                    storageId,
                    storageToken,
                    fileName: file.name
                };
                // Drop success and upload success
                onStatusChange === null || onStatusChange === void 0 ? void 0 : onStatusChange(uploadStatusSuccess(fileRef));
            } catch (error) {
                // Drop success but upload failure
                error.name === 'AbortError' ? onStatusChange === null || onStatusChange === void 0 ? void 0 : onStatusChange(uploadStatusIdle()) : onStatusChange === null || onStatusChange === void 0 ? void 0 : onStatusChange(uploadStatusError(error));
            } finally{
                controllerRef.current = undefined;
            }
        });
        return function(file) {
            return _ref.apply(this, arguments);
        };
    }(), [
        scopeConfig,
        onStatusChange,
        referenceId
    ]);
    const handleDropError = React__default.useCallback((fileRejection)=>{
        onStatusChange === null || onStatusChange === void 0 ? void 0 : onStatusChange(uploadStatusError(fileRejection));
    }, [
        onStatusChange
    ]);
    const handleCancel = React__default.useCallback(()=>{
        var ref;
        (ref = controllerRef.current) === null || ref === void 0 ? void 0 : ref.abort();
    }, []);
    const handleDelete = React__default.useCallback(()=>{
        onStatusChange === null || onStatusChange === void 0 ? void 0 : onStatusChange(uploadStatusIdle('FILE_REMOVED'));
    }, [
        onStatusChange
    ]);
    if (!scopeConfig || statusFailed(scopeConfig) || statusWarning(scopeConfig)) {
        // TODO: Do we need to account for a warning status?
        // TODO: Error view to be implemented in MACC-5453
        return /*#__PURE__*/ React__default.createElement("p", {
            color: "red"
        }, "Could not fetch config for this upload.");
    }
    if (statusLoading(scopeConfig) || statusUninit(scopeConfig)) {
        // TODO: Loading view to be implemented in MACC-5453
        return /*#__PURE__*/ React__default.createElement("p", null, "Fetching config...");
    }
    const { maxFileSizeBytes , allowedFileTypes  } = scopeConfig.result;
    return /*#__PURE__*/ React__default.createElement(Upload$1, swcHelpers.extends({}, rest, {
        uploadStatus: uploadStatus,
        onFileAccepted: handleDropSuccess,
        onFileRejected: handleDropError,
        onDelete: handleDelete,
        onCancel: handleCancel,
        maximumFileSizeBytes: maxFileSizeBytes,
        allowedFileTypes: allowedFileTypes || []
    }));
};

export { UploadContainer };
//# sourceMappingURL=UploadContainer.js.map
